"use strict";

const referrer = document.referrer;
const url = new URL(window.location.href);
const searchParams = new URLSearchParams(url.search);
const body = document.body;
let header;

// console.log("referrer:" + referrer);

let series;

let device = "pc";
let flg = false;

let productsLayout;

const mediaQueryList = window.matchMedia("(max-width:599px)");
const listener = (event) => {
  //
  if (event.matches) {
    device = "sp";
    body.classList.remove("pc");
    body.classList.add("sp");
  } else {
    device = "pc";
    body.classList.remove("sp");
    body.classList.add("pc");
  }
  //console.log("matchMedia:" + device);

  if (document.querySelector(".ssan-products") && typeof productsLayout == "function") {
    productsLayout();
  }
};

mediaQueryList.addEventListener("change", listener);
listener(mediaQueryList);

const htmlToNode = (htmlStr) => {
  if (!htmlStr || typeof htmlStr !== "string") return;
  var tmpElmt = document.createElement("div");
  tmpElmt.innerHTML = htmlStr;
  return tmpElmt.childNodes;
};
const randRange = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

const productSlideNumSet = (id) => {
  if (document.querySelectorAll(".swiper-pagination-bullet")) {
    let num = 0;

    document.querySelectorAll(".swiper-pagination-bullet").forEach((element) => {
      element.setAttribute("data-variant-id", id);

      num++;
      element.innerHTML = num;
    });
  }
};

let productSwiper;
const swiperSlideTo = (target) => {
  // //console.log("swiperSlideTo:" + id);
  let num = 0;
  let id = target.dataset.variantId;
  let slides = document.querySelectorAll(".swiper-slide");
  for (const slide of slides) {
    let vId = slide.dataset.variantId;
    // //console.log(id + ":" + vId + ":" + num + ":" + (id == vId));
    if (id == vId) {
      break;
    }
    num++;
  }
  // //console.log("swiperSlideTo:" + id + ": " + num);

  let color = target.nextElementSibling.querySelector(".swatch-label").textContent;
  document.querySelector(".js.ssan-product-color").textContent = color;

  productSwiper.slideTo(num, 0);
  productInfoSet(variantIndex(id));
};

const variantIndex = (variantId) => {
  if (document.querySelector(".swatch-input__input")) {
    if (variantId == null) {
      variantId = document.querySelector(".swatch-input__input").dataset.variantId;
    }
    productGallerySet(variantId);
    const arr = Array.from(document.querySelectorAll("variant-selects .swatch-input__input"));
    const index = arr.findIndex((element) => {
      return element.dataset.variantId === variantId;
    });
    return index + 1;
  }
};

let slide_index = 0;
let bulletsActive;
const clickEvent = (e) => {
  bulletsActive(e.target);
  let num = parseInt(e.target.textContent);
  if (num < 3) {
    productSwiper.slideTo(num + slide_index - 1, 0);
  } else {
    productSwiper.slideTo(0, 0);
  }
};

const productGallerySet = (variantId) => {
  // //console.log("productGallerySet: " + variantId);

  productSlideNumSet(variantId);

  let bullets = document.querySelectorAll(".swiper-pagination-bullet");
  let slides = document.querySelectorAll(".swiper-slide");

  const slides_arr = Array.from(slides);

  slides_arr.forEach((slide) => {
    slide_index = slides_arr.findIndex((slide) => slide.dataset.variantId === variantId);
  });
  // //console.log(slide_index);
  bulletsActive = (element) => {
    bullets.forEach((element) => {
      element.classList.remove("active");
    });
    element.classList.add("active");
  };

  bulletsActive(document.querySelector(".swiper-pagination-bullet"));

  bullets.forEach((element) => {
    element.removeEventListener("click", clickEvent, false);

    let count = 0;
    bullets.forEach((element) => {
      count++;
      element.setAttribute("data-num", count);
      element.addEventListener("click", clickEvent, false);
    });
  });
};

const productInfoSet = (num) => {
  if (num == 0) {
    num = 1;
  }
  // //console.log("productInfoSet:" + num);

  let count = 0;
  document.querySelectorAll(".js-spec_table").forEach((element) => {
    count++;
    if (count == num) {
      element.style.display = "block";
    } else {
      element.style.display = "none";
    }
  });
};

//
(function () {
  let mousePosX_pre = 0;
  let mousePosY_pre = 0;
  let scroll_pre = 0;
  let n1 = 1;
  let n2 = 1;
  let timing = 10;
  let max = 6;

  let scrollTop;
  let items;
  let itemsArray;

  let $contact;
  let $txt;

  let movefun = (event) => {
    event.preventDefault();
  };
  const noScroll = (flg) => {
    if (flg) {
      scrollTop = window.scrollY;

      body.classList.add("noscroll");
      body.style.top = scrollTop * -1 + "px";

      // スクロール停止の処理
      if (device == "pc") {
        window.addEventListener("touchmove", movefun, {
          passive: false,
        });
      }
    } else {
      // $("body").removeClass("noscroll");
      body.classList.remove("noscroll");
      //$(window).off('.noScroll');
      // スクロール停止することを停止する処理
      if (device == "pc") {
        window.removeEventListener("touchmove", movefun, {
          passive: false,
        });
      }
      window.scrollTo(0, scrollTop);
    }
  };

  let productsLayout_flg = false;
  productsLayout = () => {
    //console.log("productsLayout:" + device);
    if (device == "pc") {
      let pre_row;
      let h;
      let h_arr = [];
      let paddingTop = 45 + 24;
      let timerID;

      const loadEnd = () => {
        //console.log("loadEnd");
        document.querySelectorAll(".spacer").forEach((element) => {
          h = element.getBoundingClientRect().y - paddingTop - 5;
          h_arr.push(h);
        });

        let count = 0;
        document.querySelectorAll(".js-aside-index__item").forEach((element) => {
          count++;
          element.style.top = h_arr[count - 1] + "px";
        });
      };
      setTimeout(loadEnd, 0);
    } else {
      let count = 0;
      document.querySelectorAll(".js-aside-index__item").forEach((element) => {
        count++;
        let html = element.innerHTML;
        let spacer = document.querySelector(".spacer[data-row-num='" + count + "']");
        spacer.innerHTML = html;
      });
      if (!productsLayout_flg) {
        productsLayout_flg = true;
      }
    }

    // let medias = document.querySelectorAll("#product-grid .media img:first-child");
    // let media_max = medias.length;

    // //console.log(media_max);

    // timerID = setInterval(() => {
    //   let count = 0;
    //   medias.forEach((img) => {
    //     let src = img.getAttribute("src");

    //     if (img.complete) {
    //       img.classList.add("loaded");
    //       count++;
    //       //console.log(count + ":" + media_max);
    //       if (count >= media_max) {
    //         loadEnd();
    //         clearInterval(timerID);
    //         timerID = null;
    //       }
    //     }
    //   });
    // }, 100);
  };

  const mouseXY = (e) => {
    //イベントオブジェクトを参照し、カーソル位置情報を取得
    const mousePosX = e.clientX;
    const mousePosY = e.clientY;

    let d = Math.sqrt(Math.pow(mousePosX - mousePosX_pre, 2) + Math.pow(mousePosY - mousePosY_pre, 2));

    mousePosX_pre = mousePosX;
    mousePosY_pre = mousePosY;

    // //console.log(mousePosX + "," + mousePosY + ":" + d);
    if (d >= 2) {
      n1++;
      if (n1 > timing) {
        n1 = 1;
        n2++;
        if (n2 > max) {
          n2 = 1;
        }
      }

      bgChange(n2);
    }
  };

  const scrollY = () => {
    let scroll = window.scrollY;

    let d = Math.abs(scroll_pre - scroll);

    // if ($txt.getBoundingClientRect().top < 50) {
    //   $contact.classList.add("black");
    // } else {
    //   $contact.classList.remove("black");
    // }

    if (d >= 0) {
      n1++;
      if (n1 > timing) {
        n1 = 1;
        n2++;
        if (n2 > max) {
          n2 = 1;
        }
      }

      bgChange(n2);
    }
    scroll_pre = scroll;
  };

  const bgChange = (num) => {
    // //console.log(num);
    itemsArray.forEach((item) => {
      item.style.display = "none";
    });
    itemsArray[num - 1].style.display = "block";
  };

  history.scrollRestoration = "manual";
  window.addEventListener("afuterunload", (event) => {
    gsap.set(window, {
      scrollTo: { y: 0 },
    });
  });
  document.addEventListener("DOMContentLoaded", () => {
    let hash = location.hash;
    let lang = document.querySelector("html").getAttribute("lang");
    //console.log("lang:" + lang);
    let skip_flg = false;
    header = document.querySelector(".header");

    if (hash) {
      setTimeout(() => {
        gsap.to(window, {
          ease: Power3.easeInOut,
          duration: 1,
          delay: 0,
          scrollTo: { y: hash, offsetY: 30 },
          //autoKill: true
        });
      }, 100);
    }
    const init = () => {
      if (document.querySelector(".js-back")) {
        document.querySelector(".js-back").addEventListener("click", () => {
          history.back();
        });
      }

      const langSet = () => {
        if (document.querySelector(".js-lang-select")) {
          let scrollY = sessionStorage.getItem("scrollY");

          if (scrollY != null) {
            // //console.log(scrollY);

            body.style.opacity = 0;
            setTimeout(() => {
              // header.style.opacity = 0;
              window.scroll(0, scrollY);
              sessionStorage.removeItem("scrollY");
              gsap.to(body, { opacity: 1, duration: 0.5, ease: Power3.easeOut, delay: 0 });
            }, 100);
          }
          // const url = new URL(window.location.href);
          // if (document.querySelector(".js-lang-select").dataset.locale == "ja") {
          //   document.querySelector(".js-lang-select").textContent = "EN";
          // } else {
          //   document.querySelector(".js-lang-select").textContent = "JP";
          // }
          document.querySelectorAll(".js-lang-select").forEach((element) => {
            let body = document.body;
            element.addEventListener("click", (e) => {
              // //console.log(url.pathname + url.search);

              sessionStorage.setItem("scrollY", window.scrollY);
              header.style.opacity = 0;
              gsap.to(body, {
                opacity: 0,
                duration: 0.5,
                ease: Power3.easeOut,
                onComplete: () => {
                  let to_url = url.pathname + url.search;
                  if (e.target.dataset.locale == "ja") {
                    window.location = "/en" + to_url;
                  } else {
                    window.location = to_url.replace("/en/", "/");
                  }
                },
              });
              e.preventDefault(); //バブリングの停止
              e.stopPropagation(); //イベントキャンセル
            });
          });
        }
      };

      const menuSet = () => {
        let btn_menu = document.querySelector(".js-btn-menu");
        let menu = document.querySelector(".js-menu");

        btn_menu.addEventListener("click", (e) => {
          menu.classList.toggle("active");
          if (menu.classList.contains("active")) {
            btn_menu.textContent = "Close";
            // noScroll(true);
          } else {
            btn_menu.textContent = "Menu";
            // noScroll(false);
          }
        });

        document.addEventListener("click", (e) => {
          if (menu.classList.contains("active")) {
            // //console.log(e.target.closest(".js-menu"));
            if (!e.target.closest(".js-menu") && !e.target.closest(".js-btn-menu")) {
              menu.classList.remove("active");
              btn_menu.textContent = "Menu";
            }
          }
        });
      };

      langSet();
      menuSet();
    };

    init();

    //modal{
    if (document.querySelector(".js-comingsoon-modal_")) {
      let modal = document.querySelector(".js-comingsoon-modal");
      setTimeout(() => {
        modal.classList.add("show");
      }, 1000);
      document.querySelectorAll(".js-close-modal").forEach((element) => {
        element.addEventListener("click", (e) => {
          e.preventDefault(); //バブリングの停止
          e.stopPropagation(); //イベントキャンセル

          if (modal) {
            modal.style.display = "none";
            // noScroll(false);
          }
        });
      });
    }

    // Home
    if (document.querySelector("#home")) {
      let time1 = 5000;

      //イントロスキップ
      if (searchParams.get("test") == "1" || referrer.indexOf("ssan.jp") > 0 || referrer.indexOf("shopifypreview") > 0) {
        document.querySelector(".ssan").classList.remove("noscroll");
        document.querySelector(".teaser").classList.add("skip");
        // document.querySelector(".ssan-home-cover-fixed").classList.add("end");
        // document.querySelector(".ssan-home-cover-logo").classList.add("abs");

        time1 = 0;
      }

      document.querySelector(".teaser").classList.add("fadeIn");

      items = document.querySelectorAll(".teaser-bg__item");
      itemsArray = Array.from(items);

      $contact = document.querySelector(".teaser-contact");
      $txt = document.querySelector(".teaser-txt");

      let numbers = `<ul class="ssan-grid ssan-numbers-grid js-numbers js-waypoint">
      <li class="ssan-grid__item ssan-numbers-grid__item ssan-numbers-grid__item--1" data-name="about">
        <a href="#about" class="js-anchor">01 <span>ABOUT SSAN</span></a>
      </li>
      <li class="ssan-grid__item ssan-numbers-grid__item ssan-numbers-grid__item--2" data-name="artisanal">
        <a href="#artisanal" class="js-anchor">02 <span>ARTISANAL <br class="sp">SUSTAINABILITY</span></a>
      </li>
      <li class="ssan-grid__item ssan-numbers-grid__item ssan-numbers-grid__item--3" data-name="shigaraki-yaki">
        <a href="#shigaraki-yaki" class="js-anchor">03 <span>CULTURAL LANDSCAPES</span></a>
      </li>
    </ul>`;

      if (document.querySelector(".ssan-home-about")) {
        document.querySelector(".ssan-home-about").insertAdjacentHTML("beforebegin", numbers);
      }

      if (document.querySelectorAll(".js-anchor")) {
        document.querySelectorAll(".js-anchor").forEach((element) => {
          element.addEventListener("click", (e) => {
            let href = e.currentTarget.getAttribute("href");
            // //console.log(e.target + ":" + href);
            gsap.to(window, {
              ease: Power3.easeInOut,
              duration: 1,
              delay: 0,
              scrollTo: { y: href, offsetY: 30 },
              //autoKill: true
            });
            e.preventDefault(); //バブリングの停止
            e.stopPropagation(); //イベントキャンセル
          });
        });
      }
      setTimeout(() => {
        if (document.querySelector("#home")) {
          document.querySelector(".ssan").classList.remove("noscroll");

          let logo = document.querySelector(".js-logo");
          let logo_area = document.querySelector(".js-logo-area");

          if (logo) {
            logo.classList.add("abs");
          }

          setTimeout(() => {
            document.querySelector(".ssan-home-cover-fixed").classList.add("end");
          }, 800);

          if (logo_area) {
            logo_area.addEventListener("click", (e) => {
              // //console.log("logo");

              gsap.to(window, {
                ease: Power3.easeInOut,
                duration: 1,
                delay: 0,
                scrollTo: { y: 0 },
                //autoKill: true
              });

              e.preventDefault(); //バブリングの停止
              e.stopPropagation(); //イベントキャンセル
            });
          }

          // let numbers = document.querySelector(".js-numbers");

          let cover_scroll_flg = true;
          // //console.log("mouseXY");
          window.addEventListener("mousemove", function (e) {
            if (device == "pc" && cover_scroll_flg && !document.querySelector(".js-menu").classList.contains("active")) {
              mouseXY(e);
            }
          });

          window.addEventListener("scroll", function (e) {
            if (document.querySelector("#home")) {
              if (device == "sp") {
                scrollY();
              }

              let scroll_y = window.scrollY;
              let window_h = window.innerHeight;
              // let y = logo.getBoundingClientRect().top;
              let diff_y = (55 / 1280) * window.innerWidth;
              // let numbers_y = numbers.getBoundingClientRect().top;

              if (window_h / 2 - scroll_y <= 0) {
                cover_scroll_flg = false;
              } else {
                cover_scroll_flg = true;
              }

              // if (scroll_y > window_h) {
              //   this.document.querySelector(".ssan-home-cover").style.visibility = "hidden";
              // } else {
              //   this.document.querySelector(".ssan-home-cover").style.visibility = "visible";
              // }
              // //console.log(cover_scroll_flg);

              if (device == "sp") {
                diff_y = (43 / 375) * window.innerWidth;
              }

              // //console.log(window_h / 2 - scroll_y + ":" + diff_y);

              if (!body.classList.contains("noscroll")) {
                if (window_h / 2 - scroll_y <= diff_y) {
                  logo.classList.add("fix");
                } else {
                  logo.classList.remove("fix");
                }
              }
            }
          });
        }

        // document.querySelectorAll(".anime-bg").forEach((element) => {
        //   element.classList.add("anime-bg--2");
        // });

        if (document.querySelector(".teaser-bg__img1")) {
          if (device == "pc") {
            setTimeout(() => {
              document.querySelector(".teaser-bg__img1").classList.add("posi");
            }, 2);
          }
        }
        if (document.querySelector(".teaser-bg")) {
          if (device == "sp") {
            setTimeout(() => {
              document.querySelector(".teaser-bg").classList.add("second");
            }, 1500);
          }
        }
      }, time1);

      if (document.querySelector(".js-featured-collection-filter")) {
        // //console.log("js-featured-collection-filter");
        const filterSelect = (type) => {
          // //console.log(type);
          document.querySelectorAll(".product-grid li").forEach((element) => {
            element.style.display = "none";
          });
          document.querySelectorAll('.product-grid li[data-type="' + type + '"]').forEach((element) => {
            element.style.display = "list-item";
          });
        };

        filterSelect("no_rim_plate");

        document.querySelectorAll(".js-featured-collection-filter li a").forEach((element) => {
          element.addEventListener("mouseover", (e) => {
            if (e.target.closest("li").dataset.type) {
              e.target
                .closest("ul")
                .querySelectorAll("li")
                .forEach((element) => {
                  element.classList.remove("current");
                });
              e.target.closest("li").classList.add("current");

              filterSelect(e.target.closest("li").dataset.type);
            }
          });
        });
      }

      const waypointInit = () => {
        let waypoint_arr = [];
        setTimeout(() => {
          var waypoints = document.querySelectorAll(".js-waypoint");
          let count = 0;
          const ttlSet = (id, direction) => {
            document.querySelectorAll(".js-numbers li").forEach((element) => {
              element.classList.remove("current");

              if (element.dataset.name == id) {
                if (direction == "down") {
                  element.classList.add("current");
                } else {
                  let prevElement = element.previousSibling.previousSibling;
                  if (prevElement) {
                    prevElement.classList.add("current");
                  } else {
                    document.querySelectorAll(".js-numbers li")[0].classList.add("current");
                  }
                }
              }
            });
          };
          waypoints.forEach((element) => {
            waypoint_arr[count - 1] = new Waypoint({
              element: element,
              handler: function (direction) {
                let id = this.element.id;
                // this.element.classList.toggle("in-view");
                // //console.log(direction);
                if (direction == "down") {
                  // //console.log(id);
                  if (id == "") {
                    //transition-delay
                    // this.element.style.transform = "translateY(" + randRange(100, 200) + "px)";
                    this.element.style.transitionDelay = randRange(1, 5) * 0.05 + "s";
                    this.element.classList.add("in");
                  }
                } else {
                }
                if (id) {
                  ttlSet(id, direction);
                }
              },
              offset: "90%",
            });
          });
        }, 2000);
      };

      const videoInit = () => {
        document.querySelectorAll("video").forEach((element) => {
          // //console.log(element);
          element.addEventListener("playing", function (e) {
            // //console.log("playing:" + e.target);
          });
          element.addEventListener("timeupdate", function (e) {
            //console.log("timeupdate:" + e.target);
            // e.target.play();
          });
        });
      };

      waypointInit();
      // videoInit();
    }

    // 商品詳細ページ
    if (document.querySelector(".ssan-product")) {
      // const url = new URL(window.location.href);
      const variantId = url.searchParams.get("variant");
      // //console.log(variant);

      series = document.querySelector(".js-series").textContent;

      // //console.log(series);

      productInfoSet(variantIndex(variantId));

      productSwiper = new Swiper(".js-product-swiper", {
        speed: 0,
        allowTouchMove: false,
        effect: "fade",
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        pagination: {
          // el: ".swiper-pagination",
          // clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      if (series == "SSAN Series") {
        productSlideNumSet(variantId);

        if (document.querySelectorAll(".swatch-input__input")) {
          document.querySelectorAll(".swatch-input__input").forEach((element) => {
            if (element.checked) {
              let id = element.dataset.variantId;
              let slides = document.querySelectorAll(".swiper-slide");
              let num = 0;
              let color = element.nextElementSibling.querySelector(".swatch-label").textContent;
              document.querySelector(".js.ssan-product-color").textContent = color;

              for (const slide of slides) {
                let vId = slide.dataset.variantId;
                // //console.log(id + ":" + vId + ":" + num + ":" + (id == vId));
                if (id == vId) {
                  break;
                }
                num++;
              }
              // //console.log("swiperSlideTo:" + id + ": " + num);

              productSwiper.slideTo(num, 0);
            }
          });
        }

        if (document.querySelector(".ssan-product-list")) {
          let event_arr;
          let num = 0;
          let num2 = 0;
          let flg = false;
          let mousemove_flg = false;
          const imageSet = (num) => {
            document.querySelectorAll(".swiper-pagination-bullet")[num - 1].click();
          };
          const slide = (e) => {
            if (e.type == "mousedown") {
              flg = true;
            } else if (e.type == "mouseleave") {
              flg = false;
            }
            if (e.type == "mouseup" || e.type == "touchstart") {
              flg = false;
              if (!mousemove_flg) {
                num++;
                if (num > 3) {
                  num = 1;
                }
              }
              mousemove_flg = false;
              if (num > 0) {
                imageSet(num);
              }
            } else if (e.type == "touchmove" || (flg && e.type == "mousemove")) {
              mousemove_flg = true;
              num2++;
              if (num2 >= 10) {
                num++;
                if (num > 3) {
                  num = 1;
                }
                num2 = 0;
              }
              if (num > 0) {
                imageSet(num);
              }
            }

            // //console.log(e.type + ":" + num);
          };

          if (device == "pc") {
            event_arr = ["mousedown", "mouseup", "mousemove", "mouseleave"];
          } else {
            event_arr = ["touchstart", "touchmove"];
          }
          event_arr.forEach((eventType) => {
            document.querySelector(".ssan-product-list").addEventListener(eventType, slide);
          });
        }
      }

      if (document.querySelector(".js.ssan-product-size")) {
        document.querySelectorAll(".js.ssan-product-size li").forEach((element) => {
          let arr = url.pathname.split("-");
          let size = arr.pop();
          let to_size = element.textContent;
          let to_url = arr.join("-") + "-" + to_size;
          if (size == to_size) {
            element.classList.add("current");
          }
          element.addEventListener("click", (e) => {
            window.location = to_url;
          });
        });
      }
    }

    // 商品一覧ページ
    if (document.querySelector(".ssan-products")) {
      // const url = new URL(window.location.href);

      const productsGrid = document.querySelector(".js-products-grid");
      const asideProducts = document.querySelector(".js-aside-products");
      const asideIndex = document.querySelector(".js-aside-index");

      let products_select_obj = { mode: "products" };
      let products_select_obj_tmp = {};
      let type = url.searchParams.get("type");
      let series = url.searchParams.get("series");
      let size = url.searchParams.get("size");
      let color = url.searchParams.get("color");
      let mode = url.searchParams.get("mode");

      const productsSort = () => {
        let lis = document.querySelectorAll(".js-products-grid li");
        let count = 0;
        const typeSort = (arr) => {
          arr.sort((a, b) => a.dataset.colorNum - b.dataset.colorNum || b.dataset.size - a.dataset.size);
          // || a.localeCompare(b)

          // //console.log("typeSort:" + separate_arr[count].length);
          if (separate_arr[count].length == 1) {
            li_arr_new.push(separate_arr[count][0]);
          } else {
            li_arr_new.push(separate_arr[count][0]);
            li_arr_new.push(separate_arr[count][1]);
          }

          count++;
          arr.forEach((li) => {
            // //console.log(count + ":" + ttl + ":" + color + ":" + size);
            li_arr_new.push(li);
          });
        };
        let li_arr = Array.from(lis);
        let li_arr_new = [];
        let separate_arr = [];
        let separate_arr_tmp = [];

        let ssan_type_arr_obj = {
          no_rim_plate: [],
          rim_plate: [],
          cup: [],
          shallow_bowl: [],
          deep_bowl: [],
          shallow_hachi: [],
          platform_plate: [],
        };
        let noto_arr = [];

        // //console.log(li_arr);

        let num = 0;
        li_arr.forEach((li) => {
          let ttl = li.dataset.ttl;
          let type = li.dataset.type;
          let size = li.dataset.size;
          let color = li.dataset.color;
          let series = li.dataset.series;
          let cla = li.classList;

          if (series == "ssan") {
            if (type !== undefined) {
              ssan_type_arr_obj[type].push(li);
            }
          } else if (series == "noto") {
            // //console.log(ttl);
            noto_arr.push(li);
          } else {
            if (cla.contains("spacer") || cla.contains("separate")) {
              separate_arr_tmp.push(li);

              if (cla.contains("spacer")) {
                separate_arr.push(separate_arr_tmp);
                separate_arr_tmp = [];
                num++;
              }
            }
          }
        });

        // //console.log(separate_arr);

        for (let key in ssan_type_arr_obj) {
          typeSort(ssan_type_arr_obj[key]);
        }

        li_arr_new.forEach((li) => {
          // let ttl = li.dataset.ttl;
          // let color = li.dataset.color;
          // let size = li.dataset.size;
          // //console.log(typeof li);
          // if (ttl) {
          li_arr_new.push(li);

          // }
        });

        li_arr_new.push(separate_arr[7][0]);
        li_arr_new.push(separate_arr[7][1]);

        noto_arr.forEach((li) => {
          li_arr_new.push(li);
        });

        li_arr_new.push(separate_arr[8][0]);
        li_arr_new.push(separate_arr[8][1]);

        // //console.log(li_arr_new);

        // //console.log(ssan_type_arr_obj);
        // //console.log(noto_arr);

        lis.forEach((li) => {
          li.remove();
        });

        // //console.log(li_arr_new);

        setTimeout(() => {}, 1);

        li_arr_new.forEach((li) => {
          document.querySelector(".js-products-grid").appendChild(li);
        });

        // document.querySelector(".js-products-grid").innerHTML = li_arr_new.join("");

        //
      };

      productsSort();

      const productsMenuInit = () => {
        const menuSet = (e) => {
          document.querySelectorAll(".js-products").forEach((element) => {
            element.classList.remove("current");
          });
          e.target.classList.add("current");
          if (e.target.classList.contains("js-products__products")) {
            // //console.log("products");
            mode = "products";
            productsProductsInit();
            // //console.log(products_select_obj);
            productsGrid.classList.remove("index");
            productsGrid.classList.add("products");
            // document.querySelectorAll(".js-products-grid li").forEach((element) => {
            //   //element.classList.remove("index");
            //   // //console.log(element.classList);
            //   if (element.classList.contains("grid__item--separate") || element.classList.contains("spacer")) {
            //     element.style.display = "none";
            //   }
            // });

            // //console.log(products_select_obj);
            // document.querySelectorAll(".js-products-filter li:first-child").forEach((element) => {
            //   element.click();
            // });

            asideProducts.style.display = "none";
            asideIndex.style.display = "none";
            gsap.fromTo(
              asideProducts,
              {
                autoAlpha: 0,
                // y: 50
              },
              {
                ease: Power3.easeOut,
                autoAlpha: 1,
                duration: 0.5,
                overwrite: true,
                y: 0,
                onStart: () => {
                  asideProducts.style.display = "flex";
                },
              }
            );

            productsURLSet();
          } else {
            // //console.log("index");
            productsGrid.classList.add("index");
            productsGrid.classList.remove("products");

            asideProducts.style.display = "none";

            gsap.set(".js-products-grid", { autoAlpha: 0 });

            gsap.to(window, {
              ease: Power3.easeInOut,
              duration: 0.5,
              delay: 0,
              scrollTo: { y: 0 },
              onComplete: () => {
                let num = 0;
                document.querySelectorAll(".product-grid li").forEach((element) => {
                  //element.classList.add("index");
                  // animation.kill(element);
                  num++;
                  if (device == "pc") {
                    productsFadeIn(element, num, 0);
                  } else {
                    if (!element.classList.contains("separate")) {
                      productsFadeIn(element, num, 0);
                    }
                  }
                });

                setTimeout(() => {
                  productsLayout();
                  gsap.fromTo(
                    asideIndex,
                    {
                      display: "block",
                      autoAlpha: 0,
                      // x: 30,
                    },
                    {
                      ease: Power3.easeOut,
                      autoAlpha: 1,
                      duration: 0.5,
                      // delay: 0.5,
                      x: 0,
                    }
                  );

                  gsap.to(".js-products-grid", { autoAlpha: 1, ease: Power3.easeOut, duration: 2, delay: 0 });
                }, 100);
              },
            });

            history.pushState(null, document.title, window.location.pathname + "?mode=index");
          }

          e.preventDefault();
          e.stopPropagation();
        };
        document.querySelectorAll(".js-products").forEach((element) => {
          element.addEventListener("click", menuSet);
        });

        gsap.fromTo(
          asideProducts,
          {
            autoAlpha: 0,
            // y: 50
          },
          {
            ease: Power3.easeOut,
            autoAlpha: 1,
            duration: 1,
            overwrite: true,
            y: 0,
          }
        );

        //console.log("mode:" + mode);
        if (mode == "products" || mode == null) {
          document.querySelector(".js-products__products").click();
        } else {
          document.querySelector(".js-products__index").click();
        }
      };

      let gsap_arr = [];
      const productsFadeIn = (element, num, duration = 1) => {
        if (gsap_arr.length) {
          gsap_arr.forEach((gsap) => {
            // gsap.pause();
            gsap.kill(element);
            gsap = null;
            gsap_arr = [];
          });
        }

        if (duration == 0) {
          // //console.log(num);
          // //console.log(element);
          gsap_arr[num - 1] = gsap.to(element, {
            autoAlpha: 1,
            display: "list-item",
            y: 0,
            scale: 1,
            delay: 0,
            duration: 0,
            overwrite: "auto",
            onStart: () => {
              // //console.log("1");
              // element.style.display = "list-item";
            },
          });
        } else {
          gsap_arr[num - 1] = gsap.fromTo(
            element,
            { autoAlpha: 0 },
            // { y: 100, scale: 0.9 },
            {
              ease: Power3.easeOut,
              display: "list-item",
              autoAlpha: 1,
              duration: duration,
              y: 0,
              scale: 1,
              delay: num * 0.02,
              overwrite: true,
              onStart: () => {
                element.style.display = "list-item";
              },
            }
          );
        }
      };
      const productsFadeOut = (element) => {
        gsap.to(element, {
          autoAlpha: 1,
          duration: 0.5,
          onStart: () => {
            element.style.display = "list-item";
          },
        });
      };
      const productsSizeSet = (type) => {
        let size_arr = [];
        let cup_size_arr = [];
        document.querySelectorAll(".js-products-item").forEach((element) => {
          let size;

          if (element.dataset.series == "ssan") {
            if (element.dataset.size == "high" || element.dataset.size == "low") {
              size = element.dataset.size;
            } else {
              // //console.log();
              size = parseInt(element.dataset.size);
            }

            if (type == "all") {
              if (element.dataset.size != "high" && element.dataset.size != "low") {
                size_arr.push(size);
              } else {
                cup_size_arr.push(size);
              }
            } else {
              if (element.dataset.type == type) {
                if (element.dataset.size == "high" || element.dataset.size == "low") {
                  cup_size_arr.push(size);
                } else {
                  size_arr.push(size);
                }
              }
            }
          }
        });

        size_arr = Array.from(new Set(size_arr));
        cup_size_arr = Array.from(new Set(cup_size_arr));

        size_arr = size_arr.sort((a, b) => (a > b ? -1 : 1));

        if (type == "all") {
          size_arr = size_arr.concat(cup_size_arr);
        } else if (type == "cup") {
          size_arr = cup_size_arr;
        }

        document.querySelectorAll(".js-products-filter--size li").forEach((element) => {
          element.remove();
        });

        let li = document.createElement("li");
        li.setAttribute("class", "current");
        li.setAttribute("data-size", "all");
        li.innerHTML = "All";

        document.querySelector(".js-products-filter--size").appendChild(li);

        size_arr.forEach((item) => {
          // //console.log(item);
          let li = document.createElement("li");

          li.setAttribute("data-size", item);
          // li.setAttribute("class", "current");
          if (item == "low" || item == "high") {
            li.innerHTML = item.toUpperCase();
          } else {
            li.innerHTML = item;
          }
          document.querySelector(".js-products-filter--size").appendChild(li);
        });
        // //console.log("filterType: " + size_arr);

        document.querySelectorAll(".js-products-filter--size li").forEach((element) => {
          element.addEventListener("click", (e) => {
            document.querySelectorAll(".js-products-filter--size li").forEach((element) => {
              element.classList.remove("current");
            });
            e.target.classList.add("current");

            let str = e.target.textContent;

            if (str == "All" || str == "HIGH" || str == "LOW") {
              str = str.toLowerCase();
            }
            products_select_obj["size"] = str;

            productsSet();
          });
        });

        products_select_obj.size = "all";
      };
      const productsURLSet = () => {
        let str = "?";
        let count = 0;
        for (let item in products_select_obj) {
          if (count == 0) {
            str += item + "=" + products_select_obj[item];
          } else {
            if (products_select_obj.series == "ssan") {
              str += "&" + item + "=" + products_select_obj[item];
            } else {
              if (item != "color") {
                str += "&" + item + "=" + products_select_obj[item];
              }
            }
          }
          count++;
        }
        // //console.log(str);
        history.pushState(null, document.title, window.location.pathname + str);
      };
      const productsFilterSet = (element, flg) => {
        if (element) {
          let ul = element.closest("ul");
          let filterType = ul.previousElementSibling.textContent.toLowerCase();

          if (element.dataset.series) {
            products_select_obj[filterType] = element.dataset.series;
          }
          if (element.dataset.type) {
            products_select_obj[filterType] = element.dataset.type;
            // products_select_obj["size"] = "all";
          }
          if (element.dataset.color) {
            products_select_obj[filterType] = element.dataset.color;
          }

          //
          if (filterType == "series") {
            if (element.dataset.series == "ssan") {
              if (Object.keys(products_select_obj_tmp).length) {
                products_select_obj = { ...products_select_obj_tmp };
              }

              if (products_select_obj["type"] == undefined) {
                products_select_obj["type"] = "all";
              }
              if (products_select_obj["size"] == undefined) {
                products_select_obj["size"] = "all";
              }
              if (products_select_obj["color"] == undefined) {
                products_select_obj["color"] = "all";
              }

              document.querySelectorAll(".js-products-description-p").forEach((element) => {
                element.style.display = "none";
                if (element.dataset.type == "all" && element.dataset.series == "ssan") {
                  element.style.display = "block";
                }
              });
            } else {
              products_select_obj_tmp = { ...products_select_obj };
              products_select_obj_tmp.series = "ssan";

              delete products_select_obj.type;
              delete products_select_obj.size;
              delete products_select_obj.color;
              document.querySelectorAll(".js-products-description-p").forEach((element) => {
                element.style.display = "none";
                if (element.dataset.series == "noto") {
                  element.style.display = "block";
                }
              });
            }
          }
          // //console.log(filterType);
          if (filterType == "type") {
            let type = element.dataset.type;
            productsSizeSet(element.dataset.type);

            document.querySelectorAll(".js-products-description-p").forEach((element) => {
              element.style.display = "none";
              if (element.dataset.type == type && element.dataset.series == "ssan") {
                element.style.display = "block";
              }
            });
          }

          if (flg) {
            productsSet();
          }
        }
      };
      const productsFilterClick = (element) => {
        if (element) {
          let ul = element.closest("ul");
          ul.querySelectorAll(".js-products-filter li").forEach((element) => {
            element.classList.remove("current");
          });
          element.classList.add("current");
        }
      };
      const productsSet = (flg) => {
        // //console.log(products_select_obj);

        if (flg) {
          for (let key in products_select_obj) {
            let str = ".js-products-filter li[data-" + key + "='" + products_select_obj[key] + "']";
            let element = document.querySelector(str);

            productsFilterSet(element, false);
            productsFilterClick(element);
          }
        }

        // if (document.querySelector('.js-products-filter li[data-series="' + series + '"]')) {
        //   document.querySelector('.js-products-filter li[data-series="' + series + '"]').click();
        // }
        // if (series == "ssan") {
        //   if (document.querySelector('.js-products-filter li[data-type="' + type + '"]')) {
        //     document.querySelector('.js-products-filter li[data-type="' + type + '"]').click();
        //   }
        //   if (document.querySelector('.js-products-filter li[data-size="' + size + '"]')) {
        //     document.querySelector('.js-products-filter li[data-size="' + size + '"]').click();
        //   }

        //   if (document.querySelector('.js-products-filter li[data-color="' + color + '"]')) {
        //     document.querySelector('.js-products-filter li[data-color="' + color + '"]').click();
        //   }
        // }

        productsURLSet();

        let filterType = document.querySelector(".ssan-products-layout-aside__type");
        let filterSize = document.querySelector(".ssan-products-layout-aside__size");
        let filterColor = document.querySelector(".ssan-products-layout-aside__color");
        if (filterType && filterSize && filterColor) {
          if (products_select_obj.series == "ssan") {
            filterType.style.display = "block";
            filterSize.style.display = "block";
            filterColor.style.display = "block";
          } else {
            filterType.style.display = "none";
            filterSize.style.display = "none";
            filterColor.style.display = "none";
          }
        }
        const fadein = () => {
          let num = 0;
          // //console.log(select_arr.length);
          select_arr.forEach(function (element) {
            num++;
            productsFadeIn(element, num);
          });
          // //console.log(element.dataset.series + ":" + products_select_obj.series);
          // if (element.dataset.series == products_select_obj.series) {
          //   if (products_select_obj.series == "ssan") {
          //     if (products_select_obj.type == "all") {
          //       // if (!element.classList.contains(".spacer") && !element.classList.contains(".separate") && element.dataset.rowNum != "1") {
          //       //   productsFadeIn(element);
          //       // }
          //       productsFadeIn(element);
          //     } else {
          //       // if (!element.classList.contains(".separate") && element.dataset.type == products_select_obj.type) {
          //       //   productsFadeIn(element);
          //       // }
          //       if (element.dataset.type == products_select_obj.type) {
          //         productsFadeIn(element);
          //       }
          //     }
          //   } else {
          //     productsFadeIn(element);
          //   }
          // }
          // if (products_select_obj.size) {
          //   // //console.log(products_select_obj.size);
          // }
          // if (products_select_obj.color) {
          //   // //console.log(products_select_obj.color);
          // }
        };
        let select_arr = [];
        document.querySelectorAll(".product-grid li").forEach((element) => {
          // element.style.display = "none";
          let series = element.dataset.series;
          let type = element.dataset.type;

          let size = element.dataset.size;
          let color = element.dataset.color;

          const selectArrSet = (element) => {
            if (!element.classList.contains("spacer") && !element.classList.contains("separate") && element.dataset.rowNum != "1") {
              select_arr.push(element);
            }
          };

          // //console.log(series);
          if (products_select_obj.series == series) {
          }
          // //console.log("size:" + products_select_obj.size + ":" + size);
          if (products_select_obj.series == "ssan") {
            if (element.dataset.series == "ssan") {
              if (products_select_obj.type == "all") {
                if (products_select_obj.size == "all") {
                  if (products_select_obj.color == "all") {
                    selectArrSet(element);
                  } else {
                    if (products_select_obj.color == color) {
                      selectArrSet(element);
                    }
                  }
                } else {
                  if (products_select_obj.size == size) {
                    if (products_select_obj.color == "all") {
                      selectArrSet(element);
                    } else {
                      if (products_select_obj.color == color) {
                        selectArrSet(element);
                      }
                    }
                  }
                }
              } else if (products_select_obj.type == type) {
                if (products_select_obj.size == "all") {
                  if (products_select_obj.color == "all") {
                    selectArrSet(element);
                  } else {
                    if (products_select_obj.color == color) {
                      selectArrSet(element);
                    }
                  }
                } else {
                  if (products_select_obj.size == size) {
                    if (products_select_obj.color == "all") {
                      selectArrSet(element);
                    } else {
                      if (products_select_obj.color == color) {
                        selectArrSet(element);
                      }
                    }
                  }
                }
              }
            }
            // if (products_select_obj.size == "all") {
            //  selectArrSet(element);
            // } else if (products_select_obj.size == size) {
            //  selectArrSet(element);
            // }

            // // //console.log(products_select_obj.color);
            // if (products_select_obj.color == "all") {
            //  selectArrSet(element);
            // } else if (products_select_obj.color == color) {
            //  selectArrSet(element);
            // }
          } else {
            if (series == "noto") {
              selectArrSet(element);
            }
          }
        });

        // const tl = gsap.timeline();
        gsap.to(window, {
          ease: Power3.easeInOut,
          duration: 0,
          delay: 0,
          scrollTo: { y: 0 },
          onComplete: () => {
            let num = 0;
            const lis = document.querySelectorAll(".product-grid li");
            lis.forEach((element) => {
              gsap.fromTo(
                element,
                { autoAlpha: 0 },
                {
                  autoAlpha: 0,
                  duration: 0,
                  delay: 0,
                  overwrite: true,
                  onComplete: () => {
                    num++;
                    element.style.display = "none";

                    if (num >= lis.length) {
                      // //console.log(`${num} : ${lis.length}`);
                      fadein();
                    }
                  },
                }
              );
            });
          },
        });
      };
      const productsFilterInit = () => {
        document.querySelectorAll(".js-products-filter li").forEach((element) => {
          element.addEventListener("click", (e) => {
            productsFilterSet(e.target, true);
            productsFilterClick(e.target);
          });
        });
      };
      const productsProductsInit = () => {
        // //console.log("productsProductsInit:" + mode);
        if (mode == "products") {
          if (!series) {
            series = "ssan";
          }
          if (series == "ssan") {
            if (!type) {
              type = "all";
            }
            if (!size) {
              size = "all";
            }
            if (!color) {
              color = "all";
            }
          }

          // //console.log(size + ":" + color);

          products_select_obj.series = series;
          if (series == "ssan") {
            products_select_obj.type = type;
            products_select_obj.size = size;
            products_select_obj.color = color;
          }

          productsSet(true);
        }
      };

      productsMenuInit();
      productsFilterInit();
      productsLayout();

      // if (document.querySelector('.js-products-filter li[data-series="' + series + '"]')) {
      //   document.querySelector('.js-products-filter li[data-series="' + series + '"]').click();
      // }
      // if (series == "ssan") {
      //   if (document.querySelector('.js-products-filter li[data-type="' + type + '"]')) {
      //     document.querySelector('.js-products-filter li[data-type="' + type + '"]').click();
      //   }
      //   if (document.querySelector('.js-products-filter li[data-size="' + size + '"]')) {
      //     document.querySelector('.js-products-filter li[data-size="' + size + '"]').click();
      //   }

      //   if (document.querySelector('.js-products-filter li[data-color="' + color + '"]')) {
      //     document.querySelector('.js-products-filter li[data-color="' + color + '"]').click();
      //   }
      // }
    }

    // ページ
    if (document.querySelector(".ssan-page")) {
      let thumbs = document.querySelectorAll(".js-page-thumb");
      let processNums = document.querySelectorAll(".js-page-process-num");
      let image = document.querySelector(".js-page-image");
      let caption = document.querySelector(".js-page-caption");
      let text_arr;

      if (lang == "ja") {
        text_arr = [
          { ttl: "粉砕・（粘土）", text: "陶器の原料は「粘土」です。通常山から掘ってきた土をこまかく砕いて作ります。信楽の土は、かつて琵琶湖のあった場所として有機物が豊富です。「ssan」では、菱三陶園が所有する破損した陶器、試作品、そのほかさまざまな理由で市場に出なかった陶器を再利用します。専用の機械によって細かく粉砕します。この時に土の色分けを行います。元々の陶器の持つ色は全て異なりますので、焼き直した後に変化する可能性も含めて、見極めて色の選別を行います。" },
          { ttl: "混錬（こんれん）", text: "細かく砕いた土を、すり潰し、混ぜ合わせ、練っていきます。成形しやすい粘土にしていくことで、しっかりとした形を保つことができます。" },
          { ttl: "成形", text: "うつわの形を作っていきます。形とサイズによって、ロクロ、タタラ成型、鋳込み、石膏型など、成型の方法が異なります。人の手で形作ること。その完成の姿を描き、形作ったのちに、コテ、ヘラ、なめし皮、スポンジや刷毛、切り弓など適切な道具を使って細部まで仕上げていきます。" },
          { ttl: "乾燥", text: "成型したものを、数日かけてゆっくりと乾かします。季節、天候や気温、湿度によって、水分を含んだ布をかぶせたり、ビニールをかぶせながら均一に乾燥させていきます。半乾きの状態で、細部の細工を行ったり、滑らかに整えたりする作業を行います。" },
          { ttl: "釉薬塗布（自然釉薬））", text: "４種類の色は、焼成の温度、釉薬の配合、土との合わさりによって作り出します。同じ釉薬を使っても、温度が違えば異なる表情を見せるように、全ての要素が合わさって、1つの色が出来上がります。ssanでは、「黒つや」「黒マット」「黒マット×白」「金彩」の４色があります。いずれも、焼成技術を駆使して作り出す、シックで品のある色バリエーションです。" },
          { ttl: "焼成", text: "焼成方法は大きく分けて2つ「酸化」と「還元」という方法があります。「酸化」とはうつわが焼成される際に、酸素と反応する現象のこと。風合いを保ちながら焼き上げていきます。「還元」は窯の中から酸素を減らしていくことで、起こす化学反応を用います。焼成温度も「酸化」より高く、より強く固く焼き上がります。" },
        ];
      } else {
        text_arr = [
          { ttl: "Pulverizing / (Clay)", text: "Clay is the raw material for pottery–usually dug up from the mountains and ground into small pieces. Shigaraki clay is rich in organic matter, as it was once the site of Lake Biwa. SSAN pottery is made by reusing damaged ceramics, prototypes, and other unmarketable ceramics. The pottery is crushed into small pieces by a special machine and color-coded. " },
          { ttl: "Kneading", text: "Finely ground clay is ground, mixed, and kneaded—made into an easily moldable clay that will hold its shape well." },
          { ttl: "Molding", text: "The shape of the ware is molded. Depending on the shape and size, there are different methods such as rokuro, tatara molding, casting, plaster mold, and human hands. After drawing and shaping its finished form, the details are finished using appropriate tools such as trowels, spatulas, tanning hides, sponges and brushes, and cut bows." },
          { ttl: "Drying", text: "The molded product is slowly dried over several days. Depending on the season, weather, temperature, and humidity, we dry them evenly by covering them with a moist cloth or plastic. When half-dried, the mold is worked on for detailing and smoothing." },
          { ttl: "Applying Glaze (organic glaze)", text: "The four colors are created by the combination of firing temperature, glaze, and how it reacts with the clay. At SSAN, the four glazes are “Shiny Black” “Matte Black” “Black / White” and “Gold”. Each are unique and formed through the Hissan Pottery firing process." },
          { ttl: "Firing", text: "There are two major firing methods: oxidation and reduction. Oxidation is when the ware react with oxygen during the firing process. This process maintains the texture of the ware as it is fired. Reduction uses a chemical reaction that occurs when oxygen is reduced in the kiln. The firing temperature is higher than that of oxidation, and the ware is baked harder and stronger." },
        ];
      }

      let thumbSelect_pre_num;
      const thumbSelect = (e) => {
        // //console.log(e.target);

        let element = e.target.closest(".js-page-thumb");

        let cap = element.querySelector(".ssan-caption").textContent;
        let src = element.querySelector("img").dataset.src;

        const process = document.querySelector(".js-page-process");
        const processTtl = document.querySelector(".js-page-process-ttl");
        const processP = document.querySelector(".js-page-process-p");
        // //console.log(src);

        //
        if (document.querySelector(".ssan-page-artisanal")) {
          if (device == "sp") {
            thumbs = e.target.closest("ul").querySelectorAll(".js-page-thumb");
          }
          if (parseInt(cap) <= 6) {
            let num = parseInt(cap);
            let ttl = text_arr[num - 1].ttl;
            let text = text_arr[num - 1].text;
            let nums = document.querySelectorAll(".ssan-page-nums__item");

            if (lang == "en") {
              element.querySelector("img").setAttribute("alt", ttl.toUpperCase());
            }
            let alt = element.querySelector("img").getAttribute("alt");

            // //console.log(cap);
            nums.forEach((element) => {
              element.classList.remove("current");

              // //console.log(element.textContent + ":" + cap);
              if (element.textContent == cap) {
                element.classList.add("current");
              }
            });
            if (device == "pc") {
              image.setAttribute("src", src);

              caption.textContent = cap + " " + alt;
            } else {
              document.querySelector(".js-page-image--2").setAttribute("src", src);
              document.querySelector(".js-page-caption--2").textContent = cap + " " + alt;
            }

            let dir, x1_1, x1_2, x2_1, x2_2;
            if (num > thumbSelect_pre_num) {
              dir = "right";
              x1_1 = 0;
              x1_2 = 10;
              x2_1 = -10;
              x2_2 = 0;
            } else {
              dir = "left";
              x1_1 = 0;
              x1_2 = -10;
              x2_1 = 10;
              x2_2 = 0;
            }
            // //console.log(dir);

            const txt = document.querySelector(".js-page-txt");
            const tl = gsap.timeline();
            // tl.stop();
            tl.fromTo(txt, { x: x1_1, opacity: 1 }, { x: x1_2, opacity: 0, duration: 0.3, ease: Power3.easeInOut });
            tl.fromTo(
              txt,
              {
                x: x2_1,
                opacity: 0,
              },
              {
                x: x2_2,
                opacity: 1,
                duration: 0.3,
                ease: Power3.easeInOut,
                onStart: () => {
                  processTtl.textContent = ttl;
                  processP.textContent = text;
                },
              }
            );
            thumbSelect_pre_num = num;
          } else {
            image.setAttribute("src", src);
            caption.textContent = cap;
          }
          thumbs.forEach((element) => {
            element.classList.remove("current");
          });
        } else {
          image.setAttribute("src", src);
          caption.textContent = cap;
          thumbs.forEach((element) => {
            element.classList.remove("current");
          });
        }
        element.classList.add("current");
      };

      ["click", "mouseover"].forEach((eventType) => {
        thumbs.forEach((element) => {
          // //console.log(element);
          element.addEventListener(eventType, thumbSelect);
        });
      });

      ["click", "mouseover"].forEach((eventType) => {
        processNums.forEach((element) => {
          // //console.log(element);
          element.addEventListener(eventType, (e) => {
            thumbs.forEach((element) => {
              let caption = element.querySelector(".ssan-caption");
              if (e.target.textContent == caption.textContent) {
                element.click();
              }
            });
          });
        });
      });

      if (document.querySelector(".js-page-thumb--1")) {
        document.querySelector(".js-page-thumb--1").click();
      }

      if (document.querySelector(".ssan-page-artisanal") && device == "sp") {
        document.querySelector(".js-page-thumb--a").click();
        document.querySelector(".js-page-thumb--1").click();
      }

      const slideClickInit = () => {
        let event_arr;
        let num_arr = [0, 0, 0];
        let num2 = 0;
        let flg = false;
        let mousemove_flg = false;

        let pageAbout = document.querySelector(".ssan-page-about");
        let pageArtisanal = document.querySelector(".ssan-page-artisanal");
        let pageShigaraki = document.querySelector(".ssan-page-shigaraki");
        let thumbs = document.querySelectorAll(".js-page-thumb");
        let max = thumbs.length;
        let max1, max2;

        if (pageArtisanal) {
          document.querySelectorAll(".ssan-page-artisanal-thumbs").forEach((element) => {
            if (element.dataset.num == "1") {
              max1 = element.querySelectorAll("li").length;
            } else {
              max2 = element.querySelectorAll("li").length;
            }
          });
          // //console.log(max1 + ":" + max2);
        }
        // //console.log("slideClickInit:" + max);

        const imageSet = (num, dataNum = 0) => {
          let n;
          // //console.log(`imageSet ${dataNum} : ${num}`);
          if (pageArtisanal) {
            // //console.log(num);
            if (device == "pc") {
              if (num >= 1 && num <= max2) {
                n = num + max1;
              } else if (num >= 7 && num <= max) {
                n = num - max2;
              }
              // //console.log(num + "→" + n);
            } else {
              n = num;
            }
          } else {
            n = num;
          }
          // dataNum = 1;
          if (dataNum == 0 || device == "pc") {
            thumbs[n - 1].click();
          } else {
            const str = ".js-page-thumbs[data-num='" + dataNum + "'] li";
            // //console.log(n + ":" + dataNum);
            // //console.log(document.querySelectorAll(str));
            document.querySelectorAll(str)[n - 1].click();
          }
        };
        let mx, mx_pre;
        const slide = (e) => {
          let num;
          let dataNum = e.target.dataset.num;
          if (dataNum == undefined) {
            dataNum = 0;
          } else {
            dataNum = parseInt(dataNum);
          }
          if (pageArtisanal && device == "sp") {
            if (dataNum == 1) {
              max = max1;
            } else if (dataNum == 2) {
              max = max2;
            }
          }
          //

          num = num_arr[dataNum];

          if (e.type == "mousedown") {
            flg = true;
          } else if (e.type == "mouseleave") {
            flg = false;
          }
          if (e.type == "mouseup" || e.type == "touchstart") {
            flg = false;
            // //console.log(dataNum + ":" + num_arr);
            if (!mousemove_flg) {
              num++;
              if (num > max) {
                num = 1;
              }
            }

            mousemove_flg = false;
            if (num > 0) {
              num_arr[dataNum] = num;

              imageSet(num_arr[dataNum], dataNum);
            }
          } else if (e.type == "touchmove" || (flg && e.type == "mousemove")) {
            let max2;
            if (e.type == "touchmove") {
              max2 = 10;
            } else {
              max2 = 10;
            }
            mx = e.offsetX;
            num2++;

            if (mx > mx_pre) {
              e.target.classList.remove("prev");

              if (num2 >= max2) {
                num++;
                if (num > max) {
                  num = 1;
                }
                num2 = 0;
              }
            } else if (mx < mx_pre) {
              e.target.classList.add("prev");

              if (num2 >= max2) {
                num--;
                if (num <= 0) {
                  num = max;
                }
                num2 = 0;
              }
            }
            // //console.log(num2 + ":" + num);
            mousemove_flg = true;

            if (num > 0) {
              num_arr[dataNum] = num;
              imageSet(num_arr[dataNum], dataNum);
            }
            mx_pre = mx;
          }
        };

        if (device == "pc") {
          event_arr = ["click", "mousedown", "mouseup", "mousemove", "mouseleave"];
        } else {
          event_arr = ["touchstart", "touchmove"];
        }

        if (pageArtisanal && device == "sp") {
          event_arr.forEach((eventType) => {
            document.querySelectorAll(".js-page-fig").forEach((element) => {
              element.addEventListener(eventType, slide);
            });
          });
        } else {
          event_arr.forEach((eventType) => {
            document.querySelector(".js-page-fig").addEventListener(eventType, slide);
          });
        }
      };

      slideClickInit();
    }

    if (document.querySelector(".ssan-cart")) {
      window.addEventListener("scroll", function (e) {
        let scroll_y = window.scrollY;
        let window_h = window.innerHeight;
        let ssan_h = document.querySelector(".ssan-cart").offsetHeight;
        let footer = document.querySelector(".ssan-cart-footer");

        if (scroll_y - (ssan_h - window_h) > 0) {
          footer.classList.add("abs");
        } else {
          footer.classList.remove("abs");
        }
      });
    }
  });

  window.addEventListener("resize", () => {
    if (document.querySelectorAll(".js-products") && device == "pc") {
      productsLayout();
    }
  });

  window.addEventListener("scroll", function (e) {
    const footerArea = document.querySelectorAll(".footer-area")[0];
    const jsBtnMenu = document.querySelector(".js-btn-menu");
    const jsLangSelect = document.querySelector(".js-lang-select");
    const headerIconCart = document.querySelector(".header__icon--cart");

    if (footerArea) {
      let scroll_y = window.scrollY;
      let window_h = window.innerHeight;
      let footerArea_top = footerArea.offsetTop;

      if (scroll_y + window_h - footerArea_top > 0) {
        // console.log("show");
        if (jsBtnMenu) {
          jsBtnMenu.classList.add("white");
        }
        if (jsLangSelect) {
          jsLangSelect.classList.add("white");
        }
        if (headerIconCart) {
          headerIconCart.classList.add("white");
        }
      } else {
        // console.log("hide");
        if (jsBtnMenu) {
          jsBtnMenu.classList.remove("white");
        }
        if (jsLangSelect) {
          jsLangSelect.classList.remove("white");
        }
        if (headerIconCart) {
          headerIconCart.classList.remove("white");
        }
      }
    }
  });
})();
